module.exports = __webpack_public_path__ + "img/cerrar_blan.8f22c1d3.png";